const SET_LOADING = (state, status) => {
  state.loading = status
}

export default {
  SET_LOADING
}



// WEBPACK FOOTER //
// ./src/store/modules/loader/mutations.js